import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dd72930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-input" }
const _hoisted_2 = { class: "container-checkbox" }
const _hoisted_3 = { class: "container-forgot" }
const _hoisted_4 = { class: "container-submit" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Log in", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CInputLogin = _resolveComponent("CInputLogin")!
  const _component_CCheckBox = _resolveComponent("CCheckBox")!
  const _component_RecaptchaV2Widget = _resolveComponent("RecaptchaV2Widget")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CToast = _resolveComponent("CToast")!
  const _component_ModalOBPassword = _resolveComponent("ModalOBPassword")!
  const _component_ModalBlockLogin = _resolveComponent("ModalBlockLogin")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "container-login",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onLogin()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_CInputLogin, {
            placeholder: 'Please input your email',
            label: 'Email',
            type: 'text',
            validate: _ctx.status.valid,
            maxlength: "256",
            onChange: _ctx.checkEmail,
            onKeypress: _ctx.checkKeyboard
          }, null, 8, ["validate", "onChange", "onKeypress"]),
          _createVNode(_component_CInputLogin, {
            placeholder: 'Please input your password',
            label: 'Password',
            type: 'password',
            validate: _ctx.status.valid,
            maxlength: "40",
            onKeypress: _ctx.checkKeyboard
          }, null, 8, ["validate", "onKeypress"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CCheckBox, {
            label: 'Keep me logged in',
            onStatus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signInForm.keep_me_logged_in = $event))
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onForgotPassword && _ctx.onForgotPassword(...args)))
            }, "Forgot Password")
          ])
        ]),
        (_ctx.needRecaptchaV2)
          ? (_openBlock(), _createBlock(_component_RecaptchaV2Widget, {
              key: 0,
              ref: "recaptchaV2",
              onVerify: _ctx.onRecaptchaV2Verify,
              onExpired: _ctx.onRecaptchaV2Expired,
              onError: _ctx.onRecaptchaV2Error
            }, null, 8, ["onVerify", "onExpired", "onError"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            class: "button-submit",
            type: "submit",
            disabled: _ctx.isLoginDisabled
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32),
      _createVNode(_component_CToast),
      _createVNode(_component_ModalOBPassword, {
        modelValue: _ctx.showModalOBPassword,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModalOBPassword) = $event)),
        username: _ctx.signInForm.username
      }, null, 8, ["modelValue", "username"]),
      _createVNode(_component_ModalBlockLogin, {
        modelValue: _ctx.showModalBlockLogin,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModalBlockLogin) = $event)),
        "lock-duration-minutes": _ctx.blockLoginLockDurationMinutes
      }, null, 8, ["modelValue", "lock-duration-minutes"])
    ]),
    _: 1
  }))
}